import React from "react";
import { setup } from "@loomhq/record-sdk";
import { isSupported } from "@loomhq/record-sdk/is-supported";
import { LOOM_API_KEY } from "../constants";
import submit from "submit-form";
import SvgIcon from "./SvgIcon";

const BUTTON_ID = "loom-button";
const INPUT_ID = "video-record-date";
const INPUT_ATHLETE = "video-record-athlete";
const INPUT_VIDEO = "video-record-id";

class VideoRecordComponent extends React.Component {
  constructor(props) {
    super(props);

    const { videoRecord } = props.locals;

    this.state = {
      inputMode: false,
      value: videoRecord ? videoRecord.sharedUrl : "",
      loomCompatible: undefined,
    };

    this.deleteVideoRecord = this.deleteVideoRecord.bind(this);
    this.toggleInputMode = this.toggleInputMode.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.saveVideoRecord = this.saveVideoRecord.bind(this);
  }

  async componentDidMount() {
    // const button = document.getElementById(BUTTON_ID);
    // Commented the above line and added the below one to try a fix for loom record
    // (only the first button with the ID was configured so worked only for one of desktop/mobile)
    const buttons = document.querySelectorAll(`#${BUTTON_ID}`);
    const { supported, error } = await isSupported();

    //     if (button == null || !supported) {
    //       this.setState({ loomCompatible: false });
    //       return;
    //     }

    // Commented the above lines and added the below ones to try a fix for loom record

    if (buttons.length === 0 || !supported) {
      this.setState({ loomCompatible: false });
      return;
    }

    this.setState({ loomCompatible: true });

    const { configureButton } = await setup({
      publicAppId: LOOM_API_KEY,
    });

    buttons.length &&
      buttons.forEach((btn) => {
        configureButton({
          element: btn,
          hooks: {
            onInsertClicked: (shareLink) => {
              const date = document.getElementById(INPUT_ID).value;
              const athleteId = document.getElementById(INPUT_ATHLETE).value;
              const _id = document.getElementById(INPUT_VIDEO).value;

              const { reportDate, type } = this.props;

              submit("/actions/exercise/edit-video-record", {
                method: "POST",
                body: {
                  date,
                  shareLink,
                  athleteId,
                  _id: _id === "null" ? null : _id,
                  type: type || "calendar",
                  reportDate: reportDate || date,
                },
              });

              if (date === this.props.date) {
                this.setState({ value: shareLink.sharedUrl, inputMode: false });
              }
            },
            onStart: () => {
              this.deleteInputFromDOM();

              const { query, videoRecord } = this.props.locals;

              // this is for keeping the date of the video in a place even if the user navigates to another pages
              const inputId = document.createElement("input");
              inputId.setAttribute("type", "hidden");
              inputId.setAttribute("id", INPUT_ID);
              inputId.setAttribute("value", this.props.date);

              document.body.appendChild(inputId);

              const inputAthlete = document.createElement("input");
              inputAthlete.setAttribute("type", "hidden");
              inputAthlete.setAttribute("id", INPUT_ATHLETE);
              inputAthlete.setAttribute("value", query.athlete);

              document.body.appendChild(inputAthlete);

              const inputVideo = document.createElement("input");
              inputVideo.setAttribute("type", "hidden");
              inputVideo.setAttribute("id", INPUT_VIDEO);
              inputVideo.setAttribute(
                "value",
                !videoRecord ? null : videoRecord._id
              );

              document.body.appendChild(inputVideo);
            },
            onCancel: () => {
              this.deleteInputFromDOM();
            },
            onError: (err) => {
              console.log("err", err);
            },
          },
        });
      });
  }

  deleteInputFromDOM() {
    if (
      document.getElementById(INPUT_ID) ||
      document.getElementById(INPUT_ATHLETE) ||
      document.getElementById(INPUT_VIDEO)
    ) {
      document.getElementById(INPUT_ID).outerHTML = "";
      document.getElementById(INPUT_VIDEO).outerHTML = "";
      document.getElementById(INPUT_ATHLETE).outerHTML = "";
    }
  }

  deleteVideoRecord() {
    const { videoRecord } = this.props.locals;
    if (!videoRecord) {
      alert("You cannot perfom this action");
      return;
    }
    submit(`/actions/exercise/delete-video-record/${videoRecord._id}`, {
      method: "GET",
    });

    this.setState({ value: "", inputMode: false });
  }

  toggleInputMode(val) {
    this.setState({ inputMode: val ? val : !this.state.inputMode }, () => {
      if (this.state.inputMode) {
        const elem = document.getElementById("video-record-input");
        elem.focus();
      }
    });
  }

  handleChange(event) {
    this.setState({ value: event.target.value });
  }

  saveVideoRecord() {
    const { date, locals, type, reportDate } = this.props;
    const { value } = this.state;
    const { query, videoRecord } = locals;

    const notEmbed = value.replace("loom.com/embed/", "loom.com/share/");

    submit(`/actions/exercise/edit-video-record`, {
      method: "POST",
      body: {
        date,
        shareLink: { sharedUrl: notEmbed },
        athleteId: query.athlete,
        _id: !videoRecord ? null : videoRecord._id,
        type: type || "calendar",
        reportDate: reportDate || date,
      },
    });

    this.setState({
      inputMode: false,
      value: value === "" && videoRecord ? videoRecord.sharedUrl : value,
    });
  }

  componentDidUpdate(prevProps) {
    const { videoRecord } = this.props.locals;
    if (prevProps.date !== this.props.date) {
      this.setState({
        value: videoRecord ? videoRecord.sharedUrl : "",
        inputMode: false,
      });
    }
    if (
      prevProps.videoRecordEmbed !== this.props.videoRecordEmbed &&
      this.props.videoRecordEmbed
    ) {
      this.setState({
        value: this.props.videoRecordEmbed,
      });
    }
  }

  openCoachVideoRecord(videoRecord) {
    submit("/actions/refresh?", {
      method: "GET",
      body: {
        "modal[type]": "coach-record-video",
        //     videoRecord,
      },
    });
  }

  render() {
    const { date, unformattedDate, locals } = this.props;
    const { inputMode, value } = this.state;
    const { videoRecord, activeUser } = locals;

    const loomLink = !!value ? value : "";

    return (
      <div
        className={`video-record-container ${
          inputMode ? "input-mode" : ""
        } ${date}`}
      >
        <div className="video-record-text-container">
          <label
            htmlFor="video-record-input"
            className="ml-2 !mb-0 mobile-hidden"
          >
            Loom Video
          </label>
          <div className="video-record-info mobile-hidden">
            <div
              className="input-container"
              onClick={() => this.toggleInputMode()}
            >
              <SvgIcon
                src="/img/new-icons/link.svg"
                classNames="absolute left-3 top-3"
                noFilterOnLight={true}
              />

              <input
                type="text"
                value={loomLink}
                placeholder="Record video or paste the loom video link"
                onChange={this.handleChange}
                id="video-record-input"
              />

              <span>
                <SvgIcon
                  src="/img/icons/loom-icon.svg"
                  classNames="h-4 w-4"
                  noFilterOnLight={true}
                />
                loom
              </span>
            </div>

            <button id={BUTTON_ID} data-button-type="secondary">
              <img src="/img/icons/loom-record.svg" className="h-4 w-4 mr-2" />
              Record Video
            </button>
          </div>

          {inputMode && (
            <div className="video-record-info only-show-mobile">
              <img
                onClick={() => this.toggleInputMode()}
                src="/img/icons/loom-icon.svg"
              />

              <div className="video-record-input">
                <input
                  type="text"
                  value={loomLink}
                  placeholder={`${
                    !this.state.loomCompatible
                      ? "Insert loom video link here"
                      : "Click on record button >"
                  }`}
                  onChange={this.handleChange}
                  onFocus={() => this.toggleInputMode(true)}
                  id="video-record-input"
                />
              </div>
            </div>
          )}

          {inputMode ? (
            <div className="video-record-buttons">
              <button
                onClick={this.deleteVideoRecord}
                data-button-type="secondary"
                className="!text-[--danger]"
              >
                Delete
              </button>
              <button onClick={this.saveVideoRecord} data-button-type="primary">
                Save
              </button>
            </div>
          ) : null}
        </div>

        {videoRecord && videoRecord.video_html ? (
          <div className="coach-record-video-wrapper only-show-mobile">
            <img
              src={videoRecord.thumbnail_url}
              style={{ width: "92px", borderRadius: "5px" }}
            />
            <div className="video-details-wrapper">
              <span>{activeUser && activeUser.name}</span>
              <span>{unformattedDate && unformattedDate.format("LL")}</span>
            </div>
            <div
              className="video-play-button"
              onClick={() => this.openCoachVideoRecord(videoRecord)}
            >
              <img src="/img/svg/icon_play.svg" />
            </div>
          </div>
        ) : (
          !inputMode && (
            <button
              className="video-record-loom only-show-mobile"
              role="button"
              data-button-type="secondary"
              id={BUTTON_ID}
              onClick={
                !this.state.loomCompatible
                  ? () => this.setState({ inputMode: true })
                  : null
              }
            >
              <img src="/img/icons/loom-icon.svg" />
              {this.state.loomCompatible ? "Record Loom Video" : "Loom Video"}
            </button>
          )
        )}
      </div>
    );
  }
}

export default VideoRecordComponent;
